export const AssetReference = {
    Widget: 'widgetReference',
    Image: 'imageReference',
    Video: 'videoReference'
};
